import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { cities, cityDistrictData } from '../data/cityData';

// KVKK Modal Bileşeni
const KVKKModal: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
}> = ({ isOpen, onClose, onAccept }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Kişisel Verilerin Korunması Kanunu (KVKK)</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>
        <div className="modal-body">
          <div className="kvkk-content">
            <h4>Kişisel Verilerin Korunması Hakkında Aydınlatma Metni</h4>

            <p><strong>Veri Sorumlusu:</strong></p>
            <p>Motopack olarak, kişisel verilerinizin güvenliği konusunda azami hassasiyet göstermekteyiz. Bu kapsamda, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, veri sorumlusu sıfatıyla, kişisel verilerinizin işlenme amaçları, hukuki sebepleri, aktarıldığı taraflar ve haklarınız konusunda sizi aydınlatmayı amaçlamaktayız.</p>

            <h5>1. Kişisel Verilerin İşlenme Amaçları</h5>
            <p>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
            <ul>
              <li>Kurye hizmeti başvurularınızın değerlendirilmesi</li>
              <li>İş ilişkisi kurulması ve yürütülmesi</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
              <li>İletişim faaliyetlerinin yürütülmesi</li>
              <li>Güvenlik ve denetim faaliyetlerinin yürütülmesi</li>
            </ul>

            <h5>2. Kişisel Verilerin Aktarılması</h5>
            <p>Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda, aşağıdaki taraflara aktarılabilecektir:</p>
            <ul>
              <li>İş ortaklarımız ve hizmet sağlayıcılarımız</li>
              <li>Yasal yükümlülüklerimiz kapsamında yetkili kamu kurum ve kuruluşları</li>
              <li>Mahkemeler ve icra müdürlükleri</li>
            </ul>

            <h5>3. Kişisel Veri Toplamanın Yöntemi ve Hukuki Sebebi</h5>
            <p>Kişisel verileriniz, elektronik ortamda ve fiziki ortamda toplanmaktadır. Bu veriler, KVKK'nın 5. maddesi kapsamında aşağıdaki hukuki sebeplere dayanılarak işlenmektedir:</p>
            <ul>
              <li>Açık rızanızın bulunması</li>
              <li>Bir sözleşmenin kurulması veya ifası ile doğrudan doğruya ilgili olması</li>
              <li>Yasal yükümlülüklerimizin yerine getirilmesi</li>
              <li>Hayati menfaatinizin korunması</li>
              <li>Bir hakkın tesisi, kullanılması veya korunması</li>
            </ul>

            <h5>4. KVKK Kapsamındaki Haklarınız</h5>
            <p>KVKK'nın 11. maddesi uyarınca sahip olduğunuz haklar:</p>
            <ul>
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</li>
              <li>Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</li>
              <li>Kişisel verilerinizin eksik veya yanlış işlenmiş olması hâlinde bunların düzeltilmesini isteme</li>
              <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
              <li>Kişisel verilerinizin aktarıldığı üçüncü kişilere yukarıda sayılan (e) ve (f) bentleri uyarınca yapılan işlemlerin bildirilmesini isteme</li>
              <li>İşlenen verilerinizin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle kişiliğinize aleyhtar sonuçlar doğurmasına itiraz etme</li>
              <li>Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
            </ul>

            <h5>5. İletişim</h5>
            <p>Yukarıda belirtilen haklarınızı kullanmak için aşağıdaki iletişim kanallarından bize ulaşabilirsiniz:</p>
            <p><strong>E-posta:</strong> kvkk@motopack.com.tr</p>
            <p><strong>Adres:</strong> Güzeloluk Mah. 1830. Sk. Florya Sitesi No: 202, Kapı No: B Muratpaşa/Antalya/Türkiye</p>
            <p><strong>Telefon:</strong> 0850 532 59 89</p>

            <p><em>Bu aydınlatma metni, KVKK'nın 10. maddesi uyarınca hazırlanmıştır ve güncellenebilir.</em></p>
          </div>
        </div>
        <div className="modal-footer">
          <button className="btn btn-primary" onClick={onAccept}>
            Okudum ve Onaylıyorum
          </button>
        </div>
      </div>
    </div>
  );
};

const HizmetVer: React.FC = () => {
  const navigate = useNavigate();
  const [isKVKKModalOpen, setIsKVKKModalOpen] = useState(false);
  // Türkiye'de kullanılan araba markaları
  const arabaMarkalari = [
    'Askam', 'BMC', 'Cenntro', 'Chery', 'Chevrolet', 'Chrysler', 'Citroen',
    'Dacia', 'Daewoo', 'Daihatsu', 'DFM', 'DFSK', 'Dodge', 'FAW', 'Fest',
    'Fiat', 'Ford', 'GAZ', 'GMC', 'HFKanuni', 'Hyundai', 'Isuzu', 'Iveco',
    'Kia', 'Lancia', 'MAN', 'Maxus', 'Mazda', 'Mercedes-Benz', 'Mitsubishi',
    'Nissan', 'Opel', 'Peugeot', 'Pontiac', 'Regal Raptor', 'Renault',
    'Seat', 'Skoda', 'Suzuki', 'Temsa', 'Tenax', 'Toyota', 'Volkswagen'
  ];

  // Türkiye'de kullanılan motosiklet markaları
  const motosikletMarkalari = [
    'Abush', 'AJP', 'Altai', 'Apachi', 'Apec', 'Aprilia', 'Ariic', 'Arora',
    'Asya', 'Bajaj', 'Baotian', 'Barossa', 'Belderia', 'Benelli', 'Bianchi',
    'Bisan', 'BMW', 'BuMoto/Jinling', 'Can-Am', 'CFmoto', 'CRN', 'CSN Motor',
    'Çelik Motor', 'Daelim', 'Delta Motorcycle', 'Derbi', 'Dofern', 'Dorado',
    'Falcon', 'Gilera', 'Haojin', 'Haojue', 'Hero', 'Honda', 'Hsun', 'Hyundai',
    'Işıldar', 'Italjet', 'Jiajue', 'Jinlun', 'Jonway', 'JPN Motor', 'Kadırga',
    'Kanuni', 'Kawasaki', 'Keeway', 'Kimmi', 'Kinetic', 'Kral Motor', 'Kuba',
    'Kymco', 'Lambretta', 'Leksas', 'Lifan', 'LML', 'Malaguti', 'Maranta',
    'Meka Motor', 'Modenas', 'Mondial', 'Motolux', 'Motoran', 'Musatti', 'Nanok',
    'OMİ', 'Peugeot', 'PGO', 'Piaggio', 'Presto', 'QJ', 'Qooder', 'Ramzey',
    'Regal Raptor', 'Revolt', 'Rialli', 'RKS', 'RMG Moto Gusto', 'Royal Alloy',
    'Rutec', 'Salcano', 'SFM', 'Shenke', 'Skyjet', 'Stmax', 'Suzuki', 'SYM',
    'Taktas Motor', 'TGB', 'Truva', 'TVS', 'UM', 'Vespa', 'Vitello', 'Voge',
    'Volta', 'Wuxi', 'Xingyue', 'Yamaha', 'Yiben', 'Yiying', 'Yuki', 'Zelsun', 'Zontes'
  ];

  const [formData, setFormData] = useState({
    tcKimlik: '',
    name: '',
    birthDate: '',
    askerlikDurumu: '',
    phone: '',
    email: '',
    esnafKurye: '',
    p1BelgeDurumu: '',
    meslekiYeterlilik: '',
    ehliyetDurumu: '',
    city: '',
    district: '',
    kuryeTuru: '',
    calismaZamani: '',
    aracVarMi: '',
    aracMarka: '',
    aracModel: '',
    aracYili: '',
    deneyimBolgeler: '',
    tanismaKanali: '',
    kvkkOnay: false,
    bilgiDogrulugu: false,
    adliSicil: null as File | null,
    ehliyetBelgesi: null as File | null,
    // Referans bilgileri
    referansAdi: '',
    referansTelefonu: ''
  });

  const [fileNames, setFileNames] = useState({
    adliSicil: '',
    ehliyetBelgesi: ''
  });

  const [filePreviews, setFilePreviews] = useState({
    adliSicil: '',
    ehliyetBelgesi: ''
  });

  const [fileErrors, setFileErrors] = useState({
    adliSicil: '',
    ehliyetBelgesi: ''
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleCityChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      city: value,
      district: '' // Şehir değiştiğinde ilçeyi sıfırla
    }));
  };

  const handleDistrictChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const { value } = e.target;
    setFormData(prev => ({
      ...prev,
      district: value
    }));
  };

  const validateFile = (file: File, fieldName: string): { isValid: boolean; error?: string } => {
    // Dosya boyutu kontrolü (5MB limit)
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (file.size > maxSize) {
      return { isValid: false, error: 'Dosya boyutu 5MB\'dan büyük olamaz.' };
    }

    // Dosya uzantısı kontrolü
    const allowedExtensions = ['.pdf', '.jpg', '.jpeg', '.png'];
    const fileName = file.name.toLowerCase();
    const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

    if (!hasValidExtension) {
      return { isValid: false, error: 'Sadece PDF, JPG, JPEG ve PNG dosyaları kabul edilir.' };
    }

    // Dosya MIME tipi kontrolü
    const allowedMimeTypes = [
      'application/pdf',
      'image/jpeg',
      'image/jpg',
      'image/png'
    ];

    if (!allowedMimeTypes.includes(file.type)) {
      return { isValid: false, error: 'Geçersiz dosya türü. Sadece PDF ve resim dosyaları kabul edilir.' };
    }

    // Dosya adı kontrolü (zararlı karakterler)
    const fileNameRegex = /^[a-zA-Z0-9ğüşıöçĞÜŞİÖÇ\s\-_\.()]+$/;
    if (!fileNameRegex.test(file.name)) {
      return { isValid: false, error: 'Dosya adında geçersiz karakterler bulunuyor. Sadece harf, rakam, boşluk, tire, alt çizgi, nokta ve parantez kullanabilirsiniz.' };
    }

    // Dosya içeriği kontrolü (basit)
    if (file.type.startsWith('image/')) {
      // Resim dosyaları için ek kontrol
      if (file.size < 1024) { // 1KB'dan küçük dosyalar şüpheli
        return { isValid: false, error: 'Dosya boyutu çok küçük, geçerli bir dosya olduğundan emin olun.' };
      }
    }

    return { isValid: true };
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, files } = e.target;
    if (files && files[0]) {
      const file = files[0];

      // Dosya validasyonu
      const validation = validateFile(file, name);
      if (!validation.isValid) {
        setFileErrors(prev => ({
          ...prev,
          [name]: validation.error || 'Bilinmeyen hata'
        }));
        e.target.value = ''; // Input'u temizle
        return;
      }

      // Hata mesajını temizle
      setFileErrors(prev => ({
        ...prev,
        [name]: ''
      }));

      setFormData(prev => ({
        ...prev,
        [name]: file
      }));
      setFileNames(prev => ({
        ...prev,
        [name]: file.name
      }));

      // Resim ve PDF dosyaları için önizleme oluştur
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (e) => {
          setFilePreviews(prev => ({
            ...prev,
            [name]: e.target?.result as string
          }));
        };
        reader.readAsDataURL(file);
      } else if (file.type === 'application/pdf') {
        // PDF dosyaları için önizleme
        const reader = new FileReader();
        reader.onload = (e) => {
          setFilePreviews(prev => ({
            ...prev,
            [name]: e.target?.result as string
          }));
        };
        reader.readAsDataURL(file);
      } else {
        // Diğer dosyalar için önizleme temizle
        setFilePreviews(prev => ({
          ...prev,
          [name]: ''
        }));
      }
    }
  };

  const removeFile = (fieldName: string) => {
    setFormData(prev => ({
      ...prev,
      [fieldName]: null
    }));
    setFileNames(prev => ({
      ...prev,
      [fieldName]: ''
    }));
    setFilePreviews(prev => ({
      ...prev,
      [fieldName]: ''
    }));
    setFileErrors(prev => ({
      ...prev,
      [fieldName]: ''
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const formElement = e.target as HTMLFormElement;
    const formDataToSend = new FormData(formElement);

    // Dosyaları state'ten FormData'ya ekle
    if (formData.adliSicil) {
      formDataToSend.set('adliSicil', formData.adliSicil as File);
    }
    if (formData.ehliyetBelgesi) {
      formDataToSend.set('ehliyetBelgesi', formData.ehliyetBelgesi as File);
    }

    fetch('https://getform.io/f/bvryopnb', {
      method: 'POST',
      body: formDataToSend,
    })
      .then(response => {
        if (response.ok) {
          alert('Başvurunuz başarıyla gönderildi! En kısa sürede sizinle iletişime geçeceğiz.');
          navigate('/tesekkur');
          formElement.reset();
          // Form state'ini de temizle
          setFormData({
            tcKimlik: '',
            name: '',
            birthDate: '',
            askerlikDurumu: '',
            phone: '',
            email: '',
            esnafKurye: '',
            p1BelgeDurumu: '',
            meslekiYeterlilik: '',
            ehliyetDurumu: '',
            city: '',
            district: '',
            kuryeTuru: '',
            calismaZamani: '',
            aracVarMi: '',
            aracMarka: '',
            aracModel: '',
            aracYili: '',
            deneyimBolgeler: '',
            tanismaKanali: '',
            kvkkOnay: false,
            bilgiDogrulugu: false,
            adliSicil: null,
            ehliyetBelgesi: null,
            // Referans bilgileri
            referansAdi: '',
            referansTelefonu: ''
          });
          setFileNames({
            adliSicil: '',
            ehliyetBelgesi: ''
          });
          setFilePreviews({
            adliSicil: '',
            ehliyetBelgesi: ''
          });
          setFileErrors({
            adliSicil: '',
            ehliyetBelgesi: ''
          });
        } else {
          alert('Başvuru gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
        }
      })
      .catch(error => {
        console.error('Form submission error:', error);
        alert('Başvuru gönderilirken bir hata oluştu. Lütfen tekrar deneyin.');
      });
  };

  const FileUploadField: React.FC<{
    id: string;
    name: string;
    label: string;
    required?: boolean;
    disabled?: boolean;
    accept?: string;
    description?: string;
  }> = ({ id, name, label, required = false, disabled = false, accept = ".pdf,.jpg,.jpeg,.png", description }) => {
    const hasFile = formData[name as keyof typeof formData] && fileNames[name as keyof typeof fileNames];
    const hasPreview = filePreviews[name as keyof typeof filePreviews];
    const fileError = fileErrors[name as keyof typeof fileErrors];
    const file = formData[name as keyof typeof formData] as File;
    const isImage = file?.type?.startsWith('image/');

    // İkon seçimi
    const getIcon = () => {
      if (name === 'adliSicil') {
        return '/icon/belge/adlisicil.png';
      } else if (name === 'ehliyetBelgesi') {
        return '/icon/belge/ehliyet.png';
      }
      return '📁'; // Varsayılan ikon
    };

    return (
      <div className="form-group">
        <label htmlFor={id}>{label} {required && '*'}</label>
        <div className="file-upload-container">
          {!hasFile ? (
            <div className={`file-upload-area ${disabled ? 'disabled' : ''} ${fileError ? 'error' : ''}`}>
              <input
                type="file"
                id={id}
                name={name}
                accept={accept}
                required={required}
                disabled={disabled}
                onChange={handleFileChange}
                className="file-input"
              />
              <div className="file-upload-content">
                <div className="file-upload-icon">
                  <img src={getIcon()} alt={label} className="file-upload-icon-img" />
                </div>
                <div className="file-upload-text">
                  <span className="file-upload-title">Dosya Seç</span>
                  <span className="file-upload-subtitle">{description || 'PDF, JPG, JPEG veya PNG'}</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="file-selected">
              {hasPreview ? (
                <div className="file-preview-container">
                  <div className="file-preview-image">
                    {isImage ? (
                      <img src={hasPreview} alt="Dosya önizleme" />
                    ) : (
                      <embed src={hasPreview} type="application/pdf" />
                    )}
                  </div>
                  <div className="file-preview-info">
                    <div className="file-details">
                      <span className="file-name">{fileNames[name as keyof typeof fileNames]}</span>
                      <span className="file-size">
                        {Math.round(file?.size / 1024)} KB
                      </span>
                    </div>
                    <button
                      type="button"
                      className="file-remove-btn"
                      onClick={() => removeFile(name)}
                      title="Dosyayı kaldır"
                    >
                      ✕
                    </button>
                  </div>
                </div>
              ) : (
                <div className="file-info">
                  <div className="file-icon">
                    <img src={getIcon()} alt={label} className="file-icon-img" />
                  </div>
                  <div className="file-details">
                    <span className="file-name">{fileNames[name as keyof typeof fileNames]}</span>
                    <span className="file-size">
                      {Math.round(file?.size / 1024)} KB
                    </span>
                  </div>
                  <button
                    type="button"
                    className="file-remove-btn"
                    onClick={() => removeFile(name)}
                    title="Dosyayı kaldır"
                  >
                    ✕
                  </button>
                </div>
              )}
            </div>
          )}
          {fileError && (
            <div className="file-error-message">
              <span className="error-icon">⚠️</span>
              <span className="error-text">{fileError}</span>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <div className="page-content">
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        color: '#fff',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 4vw, 2.75rem)',
            fontWeight: 700,
            marginBottom: '0.75rem',
            letterSpacing: '-0.02em',
          }}>
            Kurye Başvuru
          </h1>
          <p style={{ fontSize: '1.125rem', opacity: 0.9, lineHeight: 1.6 }}>
            Motopack ailesine katılmak için formu doldurun, en kısa sürede iletişime geçelim.
          </p>
        </div>
      </section>
      {/* Features Cards */}
      <section className="features-cards">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" width={24} height={24}>
                  <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>Hızlı Başvuru</h3>
              <p>Başvuru formunu doldurduktan sonra 72 saat içinde size dönüş yapıyoruz.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" width={24} height={24}>
                  <path d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>Güvenli İş Modeli</h3>
              <p>Kurye ekibimizde sabit atamalarla, belirsizlik olmadan planlı şekilde çalışırsınız.</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" width={24} height={24}>
                  <path d="M12 1v22M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>
              <h3>Rekabetçi Ücretler</h3>
              <p>Piyasa standartlarında rekabetçi ücretler ile düzenli gelir elde edin.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="form-section">
        <div className="container">
          <div className="form-container">
            <div className="form-header">
              <h2>Kurye Olmak İstiyorum</h2>
              <p>Kendi işinin patronu olmak ve Motopack ekibine katılmak için hemen başvur!</p>
            </div>
            <form className="modern-form" onSubmit={handleSubmit} encType="multipart/form-data">
              {/* 1. T.C. Kimlik no - Ad soyad */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="tcKimlik">T.C. Kimlik No *</label>
                  <input
                    type="text"
                    id="tcKimlik"
                    name="tcKimlik"
                    required
                    maxLength={11}
                    pattern="[0-9]{11}"
                    placeholder="11 haneli T.C. kimlik numarası"
                    value={formData.tcKimlik}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="name">Ad Soyad *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    placeholder="Adınız ve soyadınız"
                    value={formData.name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* 2. Doğum tarihi - Askerlik durumu */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="birthDate">Doğum Tarihi *</label>
                  <input
                    type="date"
                    id="birthDate"
                    name="birthDate"
                    required
                    value={formData.birthDate}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="askerlikDurumu">Askerlik Durumu *</label>
                  <select
                    id="askerlikDurumu"
                    name="askerlikDurumu"
                    required
                    value={formData.askerlikDurumu}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>
                    <option value="yapildi">Yapıldı</option>
                    <option value="tecilli">Tecilli</option>
                    <option value="muaf">Muaf</option>
                  </select>
                </div>
              </div>

              {/* 3. Telefon - E-posta */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="phone">Telefon *</label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    required
                    placeholder="Telefon numaranız"
                    value={formData.phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">E-posta *</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    placeholder="E-posta adresiniz"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* 4. Esnaf Kurye misiniz? - P1* Belge Durumu */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="esnafKurye">Esnaf Kurye misiniz? *</label>
                  <select
                    id="esnafKurye"
                    name="esnafKurye"
                    required
                    value={formData.esnafKurye}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>
                    <option value="evet">Evet</option>
                    <option value="hayir">Hayır</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="p1BelgeDurumu">P1* Belge Durumu *</label>
                  <select
                    id="p1BelgeDurumu"
                    name="p1BelgeDurumu"
                    required
                    value={formData.p1BelgeDurumu}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>
                    <option value="var">Var</option>
                    <option value="yok">Yok</option>
                  </select>
                </div>
              </div>

              {/* 5. Mesleki yeterlilik belgesi - Ehliyet Durumu */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="meslekiYeterlilik">Mesleki Yeterlilik Belgesi *</label>
                  <select
                    id="meslekiYeterlilik"
                    name="meslekiYeterlilik"
                    required
                    value={formData.meslekiYeterlilik}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>
                    <option value="var">Var</option>
                    <option value="yok">Yok</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="ehliyetDurumu">Ehliyet Durumu (Sınıf) *</label>
                  <select
                    id="ehliyetDurumu"
                    name="ehliyetDurumu"
                    required
                    value={formData.ehliyetDurumu}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>
                    <option value="A1">A1</option>
                    <option value="A2">A2</option>
                    <option value="A">A</option>
                    <option value="B1">B1</option>
                    <option value="B">B</option>
                    <option value="C">C</option>
                    <option value="D">D</option>
                    <option value="E">E</option>
                    <option value="yok">Yok</option>
                  </select>
                </div>
              </div>

              {/* 6. Şehir - İlçe */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="city">Şehir *</label>
                  <select
                    id="city"
                    name="city"
                    required
                    value={formData.city}
                    onChange={handleCityChange}
                  >
                    <option value="">Şehir seçiniz</option>
                    {cities.map(city => (
                      <option key={city} value={city}>{city}</option>
                    ))}
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="district">İlçe *</label>
                  <select
                    id="district"
                    name="district"
                    required
                    value={formData.district}
                    onChange={handleDistrictChange}
                    disabled={!formData.city}
                  >
                    {!formData.city ? (
                      <option value="">Önce şehir seçiniz</option>
                    ) : (
                      <>
                        <option value="">İlçe seçiniz</option>
                        {cityDistrictData[formData.city]?.map((district) => (
                          <option key={district} value={district}>{district}</option>
                        ))}
                      </>
                    )}
                  </select>
                </div>
              </div>

              {/* 7. Kurye türü - Çalışma zamanı */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="kuryeTuru">Kurye Türü *</label>
                  <select
                    id="kuryeTuru"
                    name="kuryeTuru"
                    required
                    value={formData.kuryeTuru}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>
                    <option value="motorlu">Motorlu Kurye</option>
                    <option value="aracli">Araçlı Kurye</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="calismaZamani">Çalışma Zamanı *</label>
                  <select
                    id="calismaZamani"
                    name="calismaZamani"
                    required
                    value={formData.calismaZamani}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>
                    <option value="9">9 Saat</option>
                    <option value="10">10 Saat</option>
                    <option value="12">12 Saat</option>
                  </select>
                </div>
              </div>

              {/* 8. Aracınız var mı? - Marka/Model */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="aracVarMi">Aracınız var mı? *</label>
                  <select
                    id="aracVarMi"
                    name="aracVarMi"
                    required
                    value={formData.aracVarMi}
                    onChange={handleChange}
                  >
                    <option value="">Seçiniz</option>
                    <option value="yok">Yok</option>
                    <option value="araba">Araba</option>
                    <option value="motosiklet">Motosiklet</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="aracMarka">Marka {formData.aracVarMi && formData.aracVarMi !== 'yok' ? '*' : ''}</label>
                  <select
                    id="aracMarka"
                    name="aracMarka"
                    required={Boolean(formData.aracVarMi && formData.aracVarMi !== 'yok')}
                    disabled={!formData.aracVarMi || formData.aracVarMi === 'yok'}
                    value={formData.aracMarka}
                    onChange={handleChange}
                  >
                    <option value="">Marka seçiniz</option>
                    {formData.aracVarMi === 'araba' && arabaMarkalari.map(marka => (
                      <option key={marka} value={marka}>{marka}</option>
                    ))}
                    {formData.aracVarMi === 'motosiklet' && motosikletMarkalari.map(marka => (
                      <option key={marka} value={marka}>{marka}</option>
                    ))}
                  </select>
                </div>
              </div>
              {formData.aracVarMi && formData.aracVarMi !== 'yok' && (
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="aracModel">Model *</label>
                    <input
                      type="text"
                      id="aracModel"
                      name="aracModel"
                      required
                      placeholder={`${formData.aracMarka} modelini giriniz`}
                      value={formData.aracModel}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="aracYili">Yıl *</label>
                    <select
                      id="aracYili"
                      name="aracYili"
                      required
                      value={formData.aracYili}
                      onChange={handleChange}
                    >
                      <option value="">Yıl seçiniz</option>
                      {Array.from({ length: 56 }, (_, i) => 2025 - i).map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </select>
                  </div>
                </div>
              )}

              {/* 9. Deneyiminiz ve Hakim Olduğunuz Bölgeler */}
              <div className="form-row">
                <div className="form-group full-width">
                  <label htmlFor="deneyimBolgeler">Deneyiminiz ve Hakim Olduğunuz Bölgeler *</label>
                  <textarea
                    id="deneyimBolgeler"
                    name="deneyimBolgeler"
                    rows={3}
                    required
                    placeholder="Önceki kurye deneyiminiz, bildiğiniz mahalleler, semtler ve bölgeler..."
                    value={formData.deneyimBolgeler}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* 10. Referans Bilgileri */}
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="referansAdi">Referans Kişisi - Ad Soyad *</label>
                  <input
                    type="text"
                    id="referansAdi"
                    name="referansAdi"
                    required
                    placeholder="Referans kişinin adı ve soyadı"
                    value={formData.referansAdi}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="referansTelefonu">Referans Kişisi - Telefon *</label>
                  <input
                    type="tel"
                    id="referansTelefonu"
                    name="referansTelefonu"
                    required
                    placeholder="Referans kişinin telefon numarası"
                    value={formData.referansTelefonu}
                    onChange={handleChange}
                  />
                </div>
              </div>

              {/* 11. Adli Sicil Belgesi - Ehliyet Belgesi */}
              <div className="form-row">
                <FileUploadField
                  id="adliSicil"
                  name="adliSicil"
                  label="Adli Sicil Belgesi"
                  required={true}
                  description="PDF, JPG, JPEG veya PNG formatında yükleyiniz"
                />
                <FileUploadField
                  id="ehliyetBelgesi"
                  name="ehliyetBelgesi"
                  label="Ehliyet Belgesi"
                  required={true}
                  description="PDF, JPG, JPEG veya PNG formatında yükleyiniz"
                />
              </div>

              {/* 12. Tanışma Kanalları */}
              <div className="form-row">
                <div className="form-group full-width">
                  <label htmlFor="tanismaKanali">Motopack ile Nasıl Tanıştınız? *</label>
                  <div className="radio-group" style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: '0.5rem',
                    marginTop: '0.5rem',
                    overflowX: 'auto'
                  }}>
                    {[
                      { value: 'google', label: 'Google' },
                      { value: 'sosyal_medya', label: 'Sosyal Medya' },
                      { value: 'fiziksel_reklamlar', label: 'Fiziksel Reklamlar' },
                      { value: 'tavsiye', label: 'Tavsiye' },
                      { value: 'diger', label: 'Diğer' }
                    ].map(option => (
                      <label key={option.value} style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        cursor: 'pointer',
                        padding: '0.5rem 0.75rem',
                        borderRadius: 'var(--radius-md)',
                        border: '1px solid var(--gray-200)',
                        background: formData.tanismaKanali === option.value ? 'var(--primary-lightest)' : 'white',
                        transition: 'all 0.3s ease',
                        minWidth: '100px',
                        justifyContent: 'center',
                        whiteSpace: 'nowrap'
                      }}>
                        <input
                          type="radio"
                          name="tanismaKanali"
                          value={option.value}
                          required
                          checked={formData.tanismaKanali === option.value}
                          onChange={(e) => setFormData(prev => ({
                            ...prev,
                            tanismaKanali: e.target.value
                          }))}
                          style={{ margin: 0 }}
                        />
                        <span style={{
                          color: formData.tanismaKanali === option.value ? 'var(--primary-color)' : 'var(--text-secondary)',
                          fontWeight: formData.tanismaKanali === option.value ? '600' : '400'
                        }}>
                          {option.label}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>
              </div>

              {/* 13. KVKK ve Bilgi Doğruluğu Onayları */}
              <div className="form-row">
                <div className="form-group full-width">
                  <div className="checkbox-group">
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="kvkkOnay"
                        name="kvkkOnay"
                        required
                        checked={formData.kvkkOnay}
                        onChange={(e) => {
                          if (!e.target.checked) {
                            // Checkbox işareti kaldırılıyorsa direkt işlem yap
                            setFormData(prev => ({
                              ...prev,
                              kvkkOnay: false
                            }));
                          } else {
                            // Checkbox işaretleniyorsa modal aç
                            setIsKVKKModalOpen(true);
                          }
                        }}
                      />
                      <label htmlFor="kvkkOnay" style={{ cursor: 'pointer' }}>
                        Kişisel Verilerin Korunması Kanunu (KVKK) metnini okudum ve onaylıyorum. *
                      </label>
                    </div>
                    <div className="checkbox-item">
                      <input
                        type="checkbox"
                        id="bilgiDogrulugu"
                        name="bilgiDogrulugu"
                        required
                        checked={formData.bilgiDogrulugu}
                        onChange={(e) => setFormData(prev => ({
                          ...prev,
                          bilgiDogrulugu: e.target.checked
                        }))}
                      />
                      <label htmlFor="bilgiDogrulugu">
                        Sunduğum bilgilerin doğru olduğunu beyan ederim. *
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-actions" style={{ textAlign: 'center', marginTop: '2rem' }}>
                <button type="submit" className="btn btn-primary btn-large" style={{ width: '100%', maxWidth: '300px' }}>
                  Başvuruyu Gönder
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* KVKK Modal */}
      <KVKKModal
        isOpen={isKVKKModalOpen}
        onClose={() => setIsKVKKModalOpen(false)}
        onAccept={() => {
          setFormData(prev => ({
            ...prev,
            kvkkOnay: true
          }));
          setIsKVKKModalOpen(false);
        }}
      />

      {/* CTA Bölümü */}
      <section style={{
        background: 'linear-gradient(135deg, #0066CC 0%, #003D82 100%)',
        padding: '4rem 0',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', padding: '0 1.5rem' }}>
          <h2 style={{
            fontSize: '1.75rem',
            fontWeight: 700,
            color: '#fff',
            marginBottom: '0.75rem',
          }}>
            Büyük Fırsat
          </h2>
          <p style={{
            fontSize: '1rem',
            color: 'rgba(255,255,255,0.9)',
            marginBottom: '1.5rem',
          }}>
            Motopack ailesine katılın, kariyerinizi değiştirin.
          </p>
          <div style={{
            display: 'flex',
            gap: '0.75rem',
            justifyContent: 'center',
            flexWrap: 'wrap',
          }}>
            <Link
              to="/sartlar"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                padding: '0.875rem 1.75rem',
                background: '#fff',
                color: '#0066CC',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: 10,
                textDecoration: 'none',
                transition: 'all 0.2s ease',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,0.15)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
              }}
            >
              Şartları İncele
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HizmetVer; 